import { c as _c } from "react/compiler-runtime";
import { deleteLineItem } from "@lib/data/cart";
import { Spinner, Trash } from "@medusajs/icons";
import { clx } from "@medusajs/ui";
import { useState } from "react";
const DeleteButton = t0 => {
  const $ = _c(16);
  const {
    id,
    children,
    className
  } = t0;
  const [isDeleting, setIsDeleting] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async id_0 => {
      setIsDeleting(true);
      await deleteLineItem(id_0).catch(err => {
        setIsDeleting(false);
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDelete = t1;
  let t2;
  if ($[1] !== className) {
    t2 = clx("flex items-center justify-between text-small-regular", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id) {
    t3 = () => handleDelete(id);
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isDeleting) {
    t4 = isDeleting ? <Spinner className="animate-spin" /> : <Trash />;
    $[5] = isDeleting;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children) {
    t5 = <span>{children}</span>;
    $[7] = children;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <button className="flex gap-x-1 text-ui-fg-subtle hover:text-ui-fg-base cursor-pointer" onClick={t3}>{t4}{t5}</button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div className={t2}>{t6}</div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default DeleteButton;